import * as mutations from "./mutations";
import * as queries from "./queries";
import * as subscriptions from "./subscriptions";

export default {
  mutations,
  queries,
  subscriptions
};
